import { AuditSuggestion } from "Models/Audit/AuditSuggestion";
import { AuditTemplate } from "Models/Audit/AuditTemplate";
import { DataState } from "Models/Common/DataState";
import { PagedResult } from "Models/Common/PagedResult";
import { Action } from "redux";
import { AuditTemplateFilterState } from "./AuditTemplateFilterState";

export const enum ActionTypes {
    SUGGESTIONS_RETRIEVED = "AUDIT_SUGGESTIONS_RETRIEVED",
    AUDIT_SUGGESTION_RETRIEVED = "AUDIT_SUGGESTION_RETRIEVED",
    CLEAR_AUDIT_TEMPLATES = "CLEAR_AUDIT_TEMPLATES",
    AUDIT_FILTER_UPDATED = "AUDIT_FILTER_UPDATED",
    AUDIT_TEMPLATE_SAVED = "AUDIT_TEMPLATE_SAVED",
    AUDIT_PAGE_RETRIEVED = "AUDIT_PAGE_RETRIEVED",
    AUDIT_TEMPLATE_STATE_CHANGED = "AUDIT_TEMPLATE_STATE_CHANGED",
    AUDIT_TEMPLATE_RETRIEVED = "AUDIT_TEMPLATE_RETRIEVED",
    CLEAR_VALIDATION_ERRORS = "CLEAR_VALIDATION_ERRORS",
    AUDIT_TEMPLATE_DELETED = "AUDIT_TEMPLATE_DELETED",
    SHOW_VALIDATION_ERRORS = "SHOW_VALIDATION_ERRORS"
}

export interface ISuggestionsRetrievedAction extends Action {
    type: ActionTypes.SUGGESTIONS_RETRIEVED;
    data: AuditSuggestion[];
}

export interface IAuditSuggestionRetrievedAction extends Action {
    type: ActionTypes.AUDIT_SUGGESTION_RETRIEVED;
    data: AuditSuggestion;
}

export interface IClearAuditTemplateAction extends Action {
    type: ActionTypes.CLEAR_AUDIT_TEMPLATES;
}

export interface IAuditFilterUpdatedAction extends Action {
    type: ActionTypes.AUDIT_FILTER_UPDATED;
    filter: AuditTemplateFilterState;
}

export interface IAuditPageRetrievedAction extends Action {
    type: ActionTypes.AUDIT_PAGE_RETRIEVED;
    page: PagedResult<AuditTemplate>;
}

export interface IAuditTemplateStateChangedAction extends Action {
    type: ActionTypes.AUDIT_TEMPLATE_STATE_CHANGED;
    auditTemplateId?: number;
    newState: DataState;
}

export interface IAuditTemplateRetrievedAction extends Action {
    type: ActionTypes.AUDIT_TEMPLATE_RETRIEVED;
    auditTemplate: AuditTemplate;
}

export interface IClearValidationErrorsAction extends Action {
    type: ActionTypes.CLEAR_VALIDATION_ERRORS;
    auditTemplateId?: number;
}

export interface IAuditTemplateDeletedAction extends Action {
    type: ActionTypes.AUDIT_TEMPLATE_DELETED;
    auditTemplateId: number;
}

export interface IAuditTemplateSavedAction extends Action {
    type: ActionTypes.AUDIT_TEMPLATE_SAVED;
    auditTemplate: AuditTemplate;
}

export interface IShowValidationErrorsAction extends Action {
    type: ActionTypes.SHOW_VALIDATION_ERRORS;
    validationErrors: string[];
    auditTemplateId?: number;
}

export type AuditTemplateActions = ISuggestionsRetrievedAction | IAuditSuggestionRetrievedAction | IClearAuditTemplateAction | IAuditFilterUpdatedAction | IAuditPageRetrievedAction | IAuditTemplateStateChangedAction | IAuditTemplateRetrievedAction | IClearValidationErrorsAction | IAuditTemplateDeletedAction | IAuditTemplateSavedAction | IShowValidationErrorsAction;



// WEBPACK FOOTER //
// ./src/Store/AuditTemplates/AuditTemplateActionTypes.ts